export const teachingScheduleTabMeta = {
  id: "teaching",
  label: "Lịch giảng dạy",
  shortLabel: "Dạy",
};
